<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oKagav/tc-custom/9781488007330.jpg?1738384984573" alt="This image is the cover for the book Rancher's Family Wish, Wranglers Ranch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rancher's Family Wish, Wranglers Ranch
      </h1>
      <p class="bookDescription body article font2">
        <b>A home is more than a roof and four walls . . .</b><br/><br/>All Tanner Johns ever wanted was a place to call home. After inheriting Wranglers Ranch, Tanner is determined to carry on with his guardian’s legacy and turn it into a camp for troubled kids.<br/><br/>Widow Sophie Armstrong is just as focused on her goals—and on raising her two young children alone. Meeting the rugged cowboy changes everything. Tanner is a natural with her kids, and he lightens Sophie’s load in ways she couldn’t have imagined. But as the shadows in his past come between them, Tanner must convince Sophie he’s a man she can count on—for keeps.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lois Richer
      </h2>
      
      <p class="authorDescription body article">With almost two million&#160;books in print worldwide, in suspense and romance genres, Lois Richer writes about characters bold enough to face life's problems head on. Lois works hard to leave readers with a sense of hope as well as a hunger to know more about the God of whom she writes. Married for 25 years, Lois and her&#160;husband love to travel. Their small&#160;prairie town offers the perfect home base to contemplate God's inifinite love.<BR /><BR><BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4865a49e